import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useApartadaCountdown } from "../../../../hooks/useApartadaCountdown"

import "../Blocked/Blocked.css"

const Apartada = ({ roomNumber, roomTypeName, dateStatusChanged, hasIncidences }: RoomStatusProps) => {
    const { timeLeft } = useApartadaCountdown(dateStatusChanged)

    return (
        <Wrapper bgColor={"var(--card-gray)"}>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                iconBgColor="var(--bloqueada)"
                iconName="LockFill"
                roomTypeAbbreviation={roomTypeName?.[0]}
            ></RoomCardHeader>
            <RoomCardBody>
                <span className="room-card--sm--blocked__timer">{timeLeft}</span>
                <span className="room-card--sm--blocked__description">Apartada</span>
            </RoomCardBody>
        </Wrapper>
    )
}

export default Apartada
